import { Paper } from "@material-ui/core";
import React, { useState } from "react";
import { withRouter, Link } from 'react-router';
const ConfigData = ({assetInfoData, location}) => {
    return(
                <section className="asset-tech-specs" style={{margin:'25px 0 0 77px'}}>
                   <div className='tech-specs-nav'>
                        <div className='tech-nav-link'>
                            <Link className={location.pathname?.includes('config-data/manufacturers') ? 'active' : ''} to={`/config-data/manufacturers`}>Manufacturers</Link>
                        </div>
                        <div className='tech-nav-link'>
                            <Link to='/config-data/aircraftFamily' className={location.pathname?.includes('config-data/aircraftFamily') ? 'active' : ''}>Aircraft Family</Link>
                        </div>
                        <div className='tech-nav-link'>
                            <Link className={location.pathname?.includes('config-data/aircraftTypes') ? 'active' : ''} to={`/config-data/aircraftTypes`}>Aircraft Types</Link>
                        </div>
                        <div className='tech-nav-link'>
                            <Link className={location.pathname?.includes('config-data/aircraftModels') ? 'active' : ''} to={`/config-data/aircraftModels`}>Aircraft Models</Link>
                        </div>
                        <div className='tech-nav-link'>
                            <Link className={location.pathname?.includes('config-data/engineFamily') ? 'active' : ''}  to={`/config-data/engineFamily`}>Engine Family</Link>
                        </div>
                        <div className='tech-nav-link'>
                            <Link className={location.pathname?.includes('config-data/engineTypes') || location.pathname?.includes('config-data/engineType') ? 'active' : ''} to={`/config-data/engineTypes`}>Engine Types</Link>
                        </div>
                        <div className='tech-nav-link'>
                            <Link className={location.pathname?.includes('config-data/apuTypes') ? 'active' : ''} to={`/config-data/apuTypes`}>APU Types</Link>
                        </div>
                        <div className='tech-nav-link'>
                            <Link className={location.pathname?.includes('config-data/lgSubAssemblies') ? 'active' : ''} to={`/config-data/lgSubAssemblies`}>LG Sub-Assemblies</Link>
                        </div>
                        <div className='tech-nav-link'>
                            <Link className={location.pathname?.includes('config-data/region') ? 'active' : ''} to={`/config-data/region`}>Region</Link>
                        </div>
                        <div className='tech-nav-link'>
                            <Link className={location.pathname?.includes('config-data/engineLlpsConfig') ? 'active' : ''} to={`/config-data/engineLlpsConfig`}>Engine LLP Config</Link>
                        </div>
                        <div className='tech-nav-link'>
                            <Link className={location.pathname?.includes('config-data/maintenancePrograms') ? 'active' : ''} to={`/config-data/maintenancePrograms`}>Maintenance Program</Link>
                        </div>
                    </div>
                </section>
    )
}
export default withRouter(ConfigData);